import {ActionTree} from "vuex";
import {PoolFilter, PoolItem, PoolsState} from "@/store/settings/pools/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<PoolsState, RootState> = {
  getPools: ({commit, dispatch}, data: PoolFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/pools', params: data})
        .then(resp => {
          commit('setPools', resp.data.pools);
          resolve(resp)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPoolItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/pools/${id}`})
        .then((resp:any) => {
          let poolItem = <PoolItem>resp.data;
          poolItem.id = id;
          commit('setPoolItem', poolItem);
          resolve(poolItem)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  savePool: ({commit, dispatch}, data:PoolItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/pools/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getPools');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deletePool: ({commit, dispatch}, data: PoolItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/pools/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getPools');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPoolNumbers: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/pools/${id}/numbers`})
        .then((resp:any) => {
          resolve(resp.data.originators)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  importPoolNumbers: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `/acapi/pools/${data.id}/numbers/import`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getPools');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
}